/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_ErrorInputs */

const en_interview_attendance_error = /** @type {(inputs: Interview_Attendance_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save confirmation`)
};

const de_interview_attendance_error = /** @type {(inputs: Interview_Attendance_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung konnte nicht gespeichert werden`)
};

/**
* | output |
* | --- |
* | "Could not save confirmation" |
*
* @param {Interview_Attendance_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_error = /** @type {((inputs?: Interview_Attendance_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_error(inputs)
	return en_interview_attendance_error(inputs)
});